import { useAuthStore } from "@/state/authStore";
import { useCharacterStore } from "@/state/characterStore";
import { useUIStore } from "@/state/uiStore";
import { useBuffPolling } from "@/state/buffStore";
import { useNotificationStore } from "@/state/notificationStore";
import { Friend } from "@/network/RestApi";
import { useEffect } from "react";
import { LoginPanel } from "./LoginPanel";
import { VitalsHUD } from "./VitalsHUD";
import { SkillBar } from "./SkillBar";
import { Inventory } from "./Inventory";
import { SkillTreePanel } from "./SkillTreePanel";
import { QuestPanel } from "./QuestPanel";
import { ShopPanel } from "./ShopPanel";
import { GuildPanel } from "./GuildPanel";
import { FriendPanel } from "./FriendPanel";
import { PartyPanel } from "./PartyPanel";
import { TradePanel } from "./TradePanel";
import { PlayerActionPopover } from "./PlayerActionPopover";
import { Chat } from "./Chat";
import { MiniMap } from "./MiniMap";
import { CreateCharacterModal } from "./CreateCharacterModal";
import { Toast } from "./Toast";
import { StatPanel } from "./StatPanel";
import { NpcDialogPanel } from "./NpcDialogPanel";
import { StoragePanel } from "./StoragePanel";
import { TeleportPanel } from "./TeleportPanel";
import { DeathModal } from "./DeathModal";
import { AdminPanel } from "./AdminPanel";
import { PetPanel } from "./PetPanel";
import { ActionBar } from "./ActionBar";
import { FpsIndicator } from "./FpsIndicator";
import { SettingsPanel } from "./SettingsPanel";
import { ClockHud } from "./ClockHud";

export function HUD() {
  const token = useAuthStore((s) => s.accessToken);
  const character = useCharacterStore((s) => s.current);
  const open = useUIStore((s) => s.open);
  const inWorld = !!token && !!character;
  useBuffPolling(inWorld ? character?.id : null);
  const charId = character?.id;
  useEffect(() => {
    if (!inWorld || !charId) return;
    Friend.list(charId)
      .then((r) => useNotificationStore.getState().setFriendRequests(r.requests.incoming.length))
      .catch(() => { /* ignore */ });
  }, [inWorld, charId]);
  return (
    <div style={{ position: "absolute", inset: 0 }}>
      {!token && <LoginPanel />}
      {inWorld && (
        <>
          <ActionBar />
          <VitalsHUD />
          <SkillBar />
          <Chat />
          <MiniMap />
          <ClockHud />
          {open.inventory && <Inventory />}
          {open.skill && <SkillTreePanel />}
          {open.quest && <QuestPanel />}
          {open.shop && <ShopPanel />}
          {open.guild && <GuildPanel />}
          {open.friend && <FriendPanel />}
          {open.party && <PartyPanel />}
          {open.trade && <TradePanel />}
          {open.npcDialog && <NpcDialogPanel />}
          {open.storage && <StoragePanel />}
          {open.stat && <StatPanel />}
          {open.teleport && <TeleportPanel />}
          {open.admin && <AdminPanel />}
          {open.pet && <PetPanel />}
          {open.settings && <SettingsPanel />}
          <DeathModal />
          <PlayerActionPopover />
        </>
      )}
      {token && open.menu && <CreateCharacterModal />}
      <Toast />
      <FpsIndicator />
    </div>
  );
}
